import i18n, { InitOptions, FallbackLng } from "i18next";
import { initReactI18next } from "react-i18next";
import HttpBackend from "i18next-http-backend";
import appConfig from "./config";

const selectedLanguage = window.sessionStorage.getItem("selectedLanguage") ?? "en";

const i18nOptions: InitOptions = {
  lng: selectedLanguage,
  fallbackLng: "en",
  supportedLngs: ["en", "cn", "id", "kh", "jp", "tw", "th", "la", "kr"],
  interpolation: { escapeValue: false },
  backend: {
    loadPath: `${appConfig.connectionString.appBaseName}/locales/{{lng}}/translation.json`,
  },
};

i18n
  .use(HttpBackend)
  .use(initReactI18next)
  .init(i18nOptions);

export default i18n;